const GoalsPositionEnum = {
  'anti-frizz-hair-goal-concentrate': 1,
  'moisture-boosting-hair-goal-concentrate': 2,
  'shine-enhancing-hair-goal-concentrate': 3
};

const PositionEnum = {
  'straight-hair-bond-repair-shampoo': { desktop: 1, mobile: 1 },
  'wavy-hair-bond-repair-shampoo': { desktop: 2, mobile: 3 },
  'curly-hair-bond-repair-shampoo': { desktop: 3, mobile: 5 },
  'coily-hair-bond-repair-shampoo': { desktop: 4, mobile: 7 },

  //masks
  'straight-hair-bond-repair-conditioner': { desktop: 5, mobile: 2 },
  'wavy-hair-bond-repair-conditioner': { desktop: 6, mobile: 4 },
  'curly-hair-bond-repair-conditioner': { desktop: 7, mobile: 6 },
  'coily-hair-bond-repair-conditioner': { desktop: 8, mobile: 8 },
  // leave in
  'straight-and-wavy-hair-bond-repair-leave-in-treatment': {
    desktop: 9,
    mobile: 9
  },
  'curly-and-coily-hair-bond-repair-leave-in-treatment': {
    desktop: 10,
    mobile: 10
  }
};

export { PositionEnum, GoalsPositionEnum };
